// generated from 3_581 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedInAppMessageFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_in_app_message_filter"),
  comparison_key: z.enum([
    "6", // 2_049 (57.22%)
    "12", // 1_332 (37.20%)
    "3", // 146 (4.08%)
    "4", // 39 (1.09%)
    "5", // 15 (0.42%)
  ]),
  display_name: z.string(),
  // undefined: 2_805 (78.33%), defined 776 (21.67%)
  raw_value: z
    .union([
      // number samples: 581 (74.87%)
      // integer: 368 (63.34%)
      // avg: 1.31, min: 0, max: 8
      z.number().min(0),
      // string samples: 195 (25.13%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 2_089 (58.34%)
    // integer: 1_402 (67.11%)
    // avg: 1.14, min: 0, max: 182
    z.number().min(0),
    // string samples: 1_492 (41.66%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
